var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    zoomAndPan: "magnify",
    viewBox: "0 0 70.5 70.499999",
    height: 94,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.140625 0.140625 L 70.003906 0.140625 L 70.003906 70.003906 L 0.140625 70.003906 Z M 0.140625 0.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35.320312 17.503906 L 40.890625 0.140625 L 40.820312 18.378906 L 51.488281 3.574219 L 45.789062 20.894531 L 60.507812 10.128906 L 49.730469 24.851562 L 67.050781 19.152344 L 52.25 29.816406 L 70.484375 29.746094 L 53.136719 35.320312 L 70.5 40.890625 L 52.261719 40.820312 L 67.066406 51.488281 L 49.742188 45.789062 L 60.507812 60.507812 L 45.789062 49.730469 L 51.488281 67.050781 L 40.820312 52.25 L 40.890625 70.484375 L 35.320312 53.136719 L 29.746094 70.5 L 29.816406 52.261719 L 19.152344 67.066406 L 24.851562 49.742188 L 10.128906 60.507812 L 20.910156 45.789062 L 3.585938 51.488281 L 18.390625 40.820312 L 0.140625 40.890625 L 17.503906 35.320312 L 0.140625 29.746094 L 18.378906 29.816406 L 3.585938 19.152344 L 20.910156 24.851562 L 10.128906 10.128906 L 24.851562 20.910156 L 19.152344 3.585938 L 29.816406 18.390625 L 29.746094 0.140625 Z M 35.320312 17.503906 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1649ff",
    d: "M 0.140625 0.140625 L 70.5 0.140625 L 70.5 70.5 L 0.140625 70.5 Z M 0.140625 0.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.7dea2a17d5f75d239af5b2a698d7767a.svg";
export { ForwardRef as ReactComponent };